// src/pages/ProShop.jsx
import React, { useEffect, useState } from "react";
import api from "../api/axiosInstance";
// import PriceSlider from "../components/PriceSlider";

const ProShop = () => {
  const [priceRange, setPriceRange] = useState([5990, 95000]);
  const [showNumber, setShowNumber] = useState(false);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api
      .get("/proshop/get/all")
      .then((res) => setProducts(res.data))
      .catch(() => console.error("Failed to load products"));
  }, []);

  // const products = [
  //   {
  //     id: 1,
  //     name: "PGM Pro Golf Master Bag",
  //     price: 72990,
  //     image:
  //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758743368/Pgm_Pro_Golf_Master_Bag_jxmcvl.webp",
  //   },
  //   {
  //     id: 2,
  //     name: "Golf Cap",
  //     price: 65000,
  //     image:
  //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758743367/Golf_Cap_j0xd3b.jpg",
  //   },
  //   {
  //     id: 3,
  //     name: "Golf Cap Clip",
  //     price: 50990,
  //     image:
  //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758743367/GolfCapClip_bghxp0.jpg",
  //   },
  //   {
  //     id: 4,
  //     name: "Magnetic Ball Marker",
  //     price: 50990,
  //     image:
  //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758743367/Magnetic_Ball_Marker_llncut.jpg",
  //   },
  //   {
  //     id: 5,
  //     name: "Golf Belt",
  //     price: 50990,
  //     image:
  //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758743368/Golf_Belt_orenxc.jpg",
  //   },
  //   {
  //     id: 6,
  //     name: "Golf Ball",
  //     price: 50990,
  //     image:
  //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758743367/Golf_Ball_w2hbsd.jpg",
  //   },
  //   {
  //     id: 7,
  //     name: "Golf Ball",
  //     price: 50990,
  //     image:
  //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758743367/Golf_Ball_th0poh.jpg",
  //   },
  //   {
  //     id: 8,
  //     name: "Rain Cover",
  //     price: 50990,
  //     image:
  //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909164/RAIN_COVER_aepaj9.jpg",
  //   },
  //   {
  //     id: 9,
  //     name: "Iron",
  //     price: 50990,
  //     image:
  //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909163/IRON_zccgwj.jpg",
  //   },
  //   {
  //     id: 10,
  //     name: "Hand Towel",
  //     price: 50990,
  //     image:
  //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909164/HAND_TOWEL_lqzrz7.jpg",
  //   },
  //   {
  //     id: 11,
  //     name: "Small Sock",
  //     price: 50990,
  //     image:
  //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909164/SMALL_SOCK_pbkjai.jpg",
  //   },
  //   {
  //     id: 12,
  //     name: "Arm Sleeves",
  //     price: 50990,
  //     image:
  //       "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909163/ARM_SLEEVES_v0unft.jpg",
  //   },
  // ];

  const filteredProducts = products.filter(
    (p) => p.price >= priceRange[0] && p.price <= priceRange[1]
  );

  return (
    // <div className="grid grid-cols-12 gap-6 p-6">

    //   {/* <h1 className="text-3xl md:text-4xl font-bold text-center mb-12">
    //     Our Proshop
    //   </h1> */}
    //   {/* Left Sidebar */}
    //   {/* <div className="col-span-3 bg-white shadow-md rounded-lg p-4">
    //     <PriceSlider
    //       min={5990}
    //       max={95000}
    //       step={1000}
    //       onChange={(range) => setPriceRange(range)}
    //     />
    //   </div> */}

    //   {/* Right Product Grid */}
    //   <div className="col-span-9">
    //     {/* <div className="flex justify-between items-center mb-4">
    //       <h2 className="text-xl font-bold">GOLF SET</h2>
    //       <div className="flex items-center gap-4">
    //         <label className="text-sm">Sort by</label>
    //         <select className="border rounded-md p-1 text-sm">
    //           <option>Sorting</option>
    //           <option>Price: Low to High</option>
    //           <option>Price: High to Low</option>
    //         </select>
    //         <div className="flex gap-2">
    //           <button className="p-2 border rounded">🔲</button>
    //           <button className="p-2 border rounded">📃</button>
    //         </div>
    //       </div>
    //     </div> */}

    //     {/* Product Cards */}
    //     <div className="grid grid-cols-3 gap-6">
    //       {filteredProducts.map((product) => (
    //         <div
    //           key={product.id}
    //           className="border rounded-lg p-4 text-center shadow-sm hover:shadow-md transition"
    //         >
    //           <img
    //             src={product.image}
    //             alt={product.name}
    //             className="w-full h-48 object-contain mb-3"
    //           />
    //           {/* <h3 className="text-sm font-medium">{product.name}</h3> */}
    //           {/* <p className="text-red-600 font-bold">
    //             ৳ {product.price.toLocaleString()}
    //           </p> */}
    //         </div>
    //       ))}
    //     </div>
    //   </div>
    // </div>
    <div className="p-6 relative">
      {/* Floating Contact Button */}
      <div className="fixed top-20 right-2 z-50 flex flex-col items-end space-y-2 pt-2">
        <button
          onClick={() => setShowNumber(!showNumber)}
          className="bg-green-600 text-white px-4 py-2 rounded-full shadow-lg hover:bg-green-700 transition"
        >
          Contact Us
        </button>
        {showNumber && (
          <div className="bg-white text-green-700 px-4 py-2 rounded-lg shadow-md text-sm font-semibold">
            📞 +8801769662762
          </div>
        )}
      </div>

      {/* Page Title */}
      <h1 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800 uppercase">
        Pro Shop
      </h1>

      {/* Product Grid */}
      <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
        {filteredProducts?.map((product) => (
          <div
            key={product.id}
            className="border rounded-lg p-2 text-center shadow-sm hover:shadow-md transition"
          >
            <img
              src={product.imageUrls[0]}
              alt={product.name}
              className="w-full h-48 object-contain mb-3"
            />
            {/* If you want to show name & price, just uncomment */}
            <h3 className="text-sm font-medium">{product.name}</h3>
            {/* <p className="text-red-600 font-bold">
              ৳ {product.price.toLocaleString()}
            </p> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProShop;
